import { Component, input } from '@angular/core';

import { DecimalPipe } from '@angular/common';
import { YesNoIconComponent } from '@rocksoft/cdk';
import { InstalledApplication } from '@rocksoft/mdm-sdk-v2';
import { BytesToMbPipe } from '../../../pipes/bytes-to-mb.pipe';

@Component({
  selector: 'ml-mdm-apple-installed-application',
  templateUrl: './apple-installed-application.component.html',
  styleUrls: ['./apple-installed-application.component.scss'],
  imports: [YesNoIconComponent, DecimalPipe, BytesToMbPipe],
})
export class AppleInstalledApplicationComponent {
  readonly installedApplication = input.required<InstalledApplication>();
}
